import { render, staticRenderFns } from "./Cria_Denuncia.vue?vue&type=template&id=aefb0d54&scoped=true&"
import script from "./Cria_Denuncia.vue?vue&type=script&lang=js&"
export * from "./Cria_Denuncia.vue?vue&type=script&lang=js&"
import style0 from "./Cria_Denuncia.vue?vue&type=style&index=0&id=aefb0d54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefb0d54",
  null
  
)

export default component.exports